import { createContext } from 'react'

/** Lets `Modal.Footer` announce `aria-busy` while the owning dialog is saving. */
export const ModalBusyContext = createContext(false)
